module.exports = __webpack_public_path__ + "static/media/happy.fe7458d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/smileys/happy.svg
// module id = 277
// module chunks = 0